import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementIrrigationCreateMutation, useMeasurementIrrigationDeleteMutation, useMeasurementIrrigationFindAllQuery, useMeasurementIrrigationUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import toastr from "toastr";
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementIrrigationFindAllQuery(`?irrigation_system_id=${id}`);
  const [measurementIrrigationCreate, measurementIrrigationCreateResult] = useMeasurementIrrigationCreateMutation();
  const [measurementIrrigationUpdate, measurementIrrigationUpdateResult] = useMeasurementIrrigationUpdateMutation();
  const [measurementIrrigationDelete, measurementIrrigationDeleteResult] = useMeasurementIrrigationDeleteMutation();
  const [measurementIrrigation, setMeasurementIrrigation] = useState<any>();

  const [measurementList, setMeasurementList] = useState<any>();

  const [meaCount, setMeaCount] = useState<any>();

  const [is_type, setIs_typeBoolean] = useState<boolean>(false);
  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState(false)


  useEffect(() => {
    if (measurementIrrigation === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    setMeasurementList(data?.data);
    setMeaCount(data?.data?.length)
    const tempIs_type = measurementIrrigation !== null ? measurementIrrigation?.type : false;
    setIs_typeBoolean(tempIs_type)
  }, [id, data, measurementIrrigation])



  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementIrrigation?.id,
      irrigation_system_id: measurementIrrigation?.irrigation_system_id,
      irrigation_system_code: measurementIrrigation?.irrigation_system_code,
      measure_date: measurementIrrigation?.measure_date,
      usage_information: measurementIrrigation?.usage_information,
      source_name: measurementIrrigation?.source_name,
      river_water_discharge: measurementIrrigation?.river_water_discharge,

      capacity: measurementIrrigation?.capacity,
      port_design: measurementIrrigation?.port_design,

      head_construction_design: measurementIrrigation?.head_construction_design,
      maincanal_design: measurementIrrigation?.maincanal_design,
      maincanal_length: measurementIrrigation?.maincanal_length,
      maincanal_construction_design: measurementIrrigation?.maincanal_construction_design,
      maincanal_construction_num: measurementIrrigation?.maincanal_construction_num,

      waterdistribution_canal_design: measurementIrrigation?.waterdistribution_canal_design,
      discharge_well_num: measurementIrrigation?.discharge_well_num,

      waterdistribution_canal_length: measurementIrrigation?.waterdistribution_canal_length,
      irrigation_canal_design: measurementIrrigation?.irrigation_canal_design,
      irrigation_canal_length: measurementIrrigation?.irrigation_canal_length,

      airrelief_well_num: measurementIrrigation?.airrelief_well_num,

      irrigator_capacity: measurementIrrigation?.irrigator_capacity,

      water_liftingequipment_brand: measurementIrrigation?.water_liftingequipment_brand,
      water_liftingequipment_capacity: measurementIrrigation?.water_liftingequipment_capacity,
      irrigator_num: measurementIrrigation?.irrigator_num,

      waterstorage_volume: measurementIrrigation?.waterstorage_volume,
      waterstorage_length: measurementIrrigation?.waterstorage_length,
      excesswater_design: measurementIrrigation?.excesswater_design,
      excesswater_length: measurementIrrigation?.excesswater_length,
      fence_design: measurementIrrigation?.fence_design,
      fence_length: measurementIrrigation?.fence_length,

      forest_strip: measurementIrrigation?.forest_strip,
      report_autor: measurementIrrigation?.report_autor,
      report_name: measurementIrrigation?.report_name,
      report_code: measurementIrrigation?.report_code,
    },
    validationSchema: Yup.object({
      irrigation_system_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар орууна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      source_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      river_water_discharge: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      port_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      head_construction_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maincanal_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maincanal_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maincanal_construction_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maincanal_construction_num: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      waterdistribution_canal_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      discharge_well_num: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      waterdistribution_canal_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      irrigation_canal_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      irrigation_canal_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      airrelief_well_num: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      irrigator_capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      water_liftingequipment_brand: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_liftingequipment_capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      irrigator_num: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      waterstorage_volume: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterstorage_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      excesswater_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      excesswater_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      fence_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      fence_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      forest_strip: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    validateOnChange: true, validateOnBlur: true,
    onSubmit: (values: any) => {

      if (is_newCreated === false) {
        const updateList = {
          id: measurementIrrigation?.id,
          irrigation_system_id: measurementIrrigation?.irrigation_system_id,
          irrigation_system_code: values?.irrigation_system_code,
          measure_date: values?.measure_date,
          usage_information: values?.usage_information,
          source_name: values?.source_name,
          river_water_discharge: values?.river_water_discharge,

          capacity: values?.capacity,
          port_design: values?.port_design,

          head_construction_design: values?.head_construction_design,
          maincanal_design: values?.maincanal_design,
          maincanal_length: values?.maincanal_length,
          maincanal_construction_design: values?.maincanal_construction_design,
          maincanal_construction_num: values?.maincanal_construction_num,

          waterdistribution_canal_design: values?.waterdistribution_canal_design,
          discharge_well_num: values?.discharge_well_num,

          waterdistribution_canal_length: values?.waterdistribution_canal_length,
          irrigation_canal_design: values?.irrigation_canal_design,
          irrigation_canal_length: values?.irrigation_canal_length,

          is_type: is_type === undefined ? false : is_type,

          irrigator_capacity: values?.irrigator_capacity,

          airrelief_well_num: values?.airrelief_well_num,

          water_liftingequipment_brand: values?.water_liftingequipment_brand,
          water_liftingequipment_capacity: values?.water_liftingequipment_capacity,
          irrigator_num: values?.irrigator_num,

          waterstorage_volume: values?.waterstorage_volume,
          waterstorage_length: values?.waterstorage_length,
          excesswater_design: values?.excesswater_design,
          excesswater_length: values?.excesswater_length,
          fence_design: values?.fence_design,
          fence_length: values?.fence_length,

          forest_strip: values?.forest_strip,
          report_autor: values?.report_autor,
          report_name: values?.report_name,
          report_code: values?.report_code,

        }

        measurementIrrigationUpdate(updateList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Амжилтгүй!", "Амжилтгүй");
          })
        validation.resetForm();

      } else {
        const newList = {
          irrigation_system_id: id,
          irrigation_system_code: values["irrigation_system_code"],
          measure_date: values["measure_date"],
          usage_information: values["usage_information"],
          source_name: values["source_name"],
          river_water_discharge: values["river_water_discharge"],

          capacity: values["capacity"],
          port_design: values["port_design"],

          head_construction_design: values["head_construction_design"],
          maincanal_design: values["maincanal_design"],
          maincanal_length: values["maincanal_length"],
          maincanal_construction_design: values["maincanal_construction_design"],
          maincanal_construction_num: values["maincanal_construction_num"],

          waterdistribution_canal_design: values["waterdistribution_canal_design"],
          discharge_well_num: values["discharge_well_num"],

          waterdistribution_canal_length: values["waterdistribution_canal_length"],
          irrigation_canal_design: values["irrigation_canal_design"],
          irrigation_canal_length: values["irrigation_canal_length"],

          is_type: is_type === undefined ? false : is_type,

          irrigator_capacity: values["irrigator_capacity"],

          water_liftingequipment_brand: values["water_liftingequipment_brand"],
          water_liftingequipment_capacity: values["water_liftingequipment_capacity"],
          irrigator_num: values["irrigator_num"],

          waterstorage_volume: values["waterstorage_volume"],
          waterstorage_length: values["waterstorage_length"],
          excesswater_design: values["excesswater_design"],
          excesswater_length: values["excesswater_length"],
          fence_design: values["fence_design"],
          fence_length: values["fence_length"],

          forest_strip: values["forest_strip"],
          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
        };
        console.log("Form Data:", newList);

        measurementIrrigationCreate(newList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай үүслээ!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Амжилтгүй!", "Амжилтгүй");
          })
      }
    },
  });

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    console.log('===measurementIrrigation===', measurementIrrigation)
    if (measurementIrrigation) {
      measurementIrrigationDelete(measurementIrrigation.id);
      console.log('===measurementIrrigation===', measurementIrrigation)
      setDeleteModal(false);
    }
    setMeasurementIrrigation(null)
    setIs_newCreated(true)
    setIs_typeBoolean(false)
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementIrrigation(null);
                setIs_typeBoolean(false);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>
            {
              is_newCreated === false && measurementList !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementList?.purification_code}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementIrrigation(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} />
              :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="irrigation_system_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigation_system_code || ""}
                        invalid={
                          validation.touched.irrigation_system_code &&
                            validation.errors.irrigation_system_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigation_system_code &&
                        validation.errors.irrigation_system_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigation_system_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны эх үүсвэрийн буюу голын нэр  </Label>
                      <Input
                        name="source_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.source_name || ""}
                        invalid={
                          validation.touched.source_name &&
                            validation.errors.source_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.source_name &&
                        validation.errors.source_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.source_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Услалтын системийн хүчин чадал  </Label>
                      <Input
                        name="capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.capacity || ""}
                        invalid={
                          validation.touched.capacity &&
                            validation.errors.capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.capacity &&
                        validation.errors.capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Гол сувгийн хийц, зохиомж </Label>
                      <Input
                        name="maincanal_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maincanal_design || ""}
                        invalid={
                          validation.touched.maincanal_design &&
                            validation.errors.maincanal_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maincanal_design &&
                        validation.errors.maincanal_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maincanal_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Гол суваг дээрх барилгын тоо  </Label>
                      <Input
                        name="maincanal_construction_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maincanal_construction_num || ""}
                        invalid={
                          validation.touched.maincanal_construction_num &&
                            validation.errors.maincanal_construction_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maincanal_construction_num &&
                        validation.errors.maincanal_construction_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maincanal_construction_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Вантузтай худгийн тоо   </Label>
                      <Input
                        name="airrelief_well_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.airrelief_well_num || ""}
                        invalid={
                          validation.touched.airrelief_well_num &&
                            validation.errors.airrelief_well_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.airrelief_well_num &&
                        validation.errors.airrelief_well_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.airrelief_well_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усалгааны сувгийн урт  </Label>
                      <Input
                        name="irrigation_canal_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigation_canal_length || ""}
                        invalid={
                          validation.touched.irrigation_canal_length &&
                            validation.errors.irrigation_canal_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigation_canal_length &&
                        validation.errors.irrigation_canal_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigation_canal_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хүчин чадал </Label>
                      <Input
                        name="water_liftingequipment_capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_liftingequipment_capacity || ""}
                        invalid={
                          validation.touched.water_liftingequipment_capacity &&
                            validation.errors.water_liftingequipment_capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_liftingequipment_capacity &&
                        validation.errors.water_liftingequipment_capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_liftingequipment_capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тоо </Label>
                      <Input
                        name="waterstorage_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterstorage_length || ""}
                        invalid={
                          validation.touched.waterstorage_length &&
                            validation.errors.waterstorage_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterstorage_length &&
                        validation.errors.waterstorage_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterstorage_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Торон хашааны хийц  </Label>
                      <Input
                        name="fence_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.fence_design || ""}
                        invalid={
                          validation.touched.fence_design &&
                            validation.errors.fence_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.fence_design &&
                        validation.errors.fence_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.fence_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан гаргасан </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын усны зарцуулга, м3/с  </Label>
                      <Input
                        name="river_water_discharge"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.river_water_discharge || ""}
                        invalid={
                          validation.touched.river_water_discharge &&
                            validation.errors.river_water_discharge
                            ? true
                            : false
                        }
                      />
                      {validation.touched.river_water_discharge &&
                        validation.errors.river_water_discharge ? (
                        <FormFeedback type="invalid">
                          {validation.errors.river_water_discharge}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Боомтын хийц зохиомж  </Label>
                      <Input
                        name="port_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.port_design || ""}
                        invalid={
                          validation.touched.port_design &&
                            validation.errors.port_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.port_design &&
                        validation.errors.port_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.port_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гол сувгийн урт </Label>
                      <Input
                        name="maincanal_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maincanal_length || ""}
                        invalid={
                          validation.touched.maincanal_length &&
                            validation.errors.maincanal_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maincanal_length &&
                        validation.errors.maincanal_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maincanal_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус хуваарилах сувгийн хийц зохиомж  </Label>
                      <Input
                        name="waterdistribution_canal_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterdistribution_canal_design || ""}
                        invalid={
                          validation.touched.waterdistribution_canal_design &&
                            validation.errors.waterdistribution_canal_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterdistribution_canal_design &&
                        validation.errors.waterdistribution_canal_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterdistribution_canal_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус хуваарилах суваг, яндан хоолойн урт   </Label>
                      <Input
                        name="waterdistribution_canal_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterdistribution_canal_length || ""}
                        invalid={
                          validation.touched.waterdistribution_canal_length &&
                            validation.errors.waterdistribution_canal_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterdistribution_canal_length &&
                        validation.errors.waterdistribution_canal_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterdistribution_canal_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> (бороожуулагч) хүчин чадал  </Label>
                      <Input
                        name="irrigator_capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigator_capacity || ""}
                        invalid={
                          validation.touched.irrigator_capacity &&
                            validation.errors.irrigator_capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigator_capacity &&
                        validation.errors.irrigator_capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigator_capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бороожуулагчын тоо  </Label>
                      <Input
                        name="irrigator_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigator_num || ""}
                        invalid={
                          validation.touched.irrigator_num &&
                            validation.errors.irrigator_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigator_num &&
                        validation.errors.irrigator_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigator_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Илүүдэл ус хаях сувгийн хийц   </Label>
                      <Input
                        name="excesswater_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.excesswater_design || ""}
                        invalid={
                          validation.touched.excesswater_design &&
                            validation.errors.excesswater_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.excesswater_design &&
                        validation.errors.excesswater_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.excesswater_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урт </Label>
                      <Input
                        name="fence_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.fence_length || ""}
                        invalid={
                          validation.touched.fence_length &&
                            validation.errors.fence_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.fence_length &&
                        validation.errors.fence_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.fence_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Услалтын системийн ашиглалтын талаарх мэдээлэл  </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Услалтын системийн төрөл   </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_typeBoolean(!is_type);
                        }}
                        checked={is_type}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Толгойн барилгын хийц, зохиомж  </Label>
                      <Input
                        name="head_construction_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.head_construction_design || ""}
                        invalid={
                          validation.touched.head_construction_design &&
                            validation.errors.head_construction_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.head_construction_design &&
                        validation.errors.head_construction_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.head_construction_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гол суваг дээрх барилгын төрөл хийц  </Label>
                      <Input
                        name="maincanal_construction_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maincanal_construction_design || ""}
                        invalid={
                          validation.touched.maincanal_construction_design &&
                            validation.errors.maincanal_construction_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maincanal_construction_design &&
                        validation.errors.maincanal_construction_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maincanal_construction_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Юүлэх худгийн тоо  </Label>
                      <Input
                        name="discharge_well_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.discharge_well_num || ""}
                        invalid={
                          validation.touched.discharge_well_num &&
                            validation.errors.discharge_well_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.discharge_well_num &&
                        validation.errors.discharge_well_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.discharge_well_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усалгааны сувгийн хийц төрөл </Label>
                      <Input
                        name="irrigation_canal_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigation_canal_design || ""}
                        invalid={
                          validation.touched.irrigation_canal_design &&
                            validation.errors.irrigation_canal_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigation_canal_design &&
                        validation.errors.irrigation_canal_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigation_canal_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус өргөх төнөг төхөөрөмжийн марк </Label>
                      <Input
                        name="water_liftingequipment_brand"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_liftingequipment_brand || ""}
                        invalid={
                          validation.touched.water_liftingequipment_brand &&
                            validation.errors.water_liftingequipment_brand
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_liftingequipment_brand &&
                        validation.errors.water_liftingequipment_brand ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_liftingequipment_brand}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус хуримтлуулах хүнхээлийн эзэлхүүн  </Label>
                      <Input
                        name="waterstorage_volume"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterstorage_volume || ""}
                        invalid={
                          validation.touched.waterstorage_volume &&
                            validation.errors.waterstorage_volume
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterstorage_volume &&
                        validation.errors.waterstorage_volume ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterstorage_volume}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урт   </Label>
                      <Input
                        name="excesswater_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.excesswater_length || ""}
                        invalid={
                          validation.touched.excesswater_length &&
                            validation.errors.excesswater_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.excesswater_length &&
                        validation.errors.excesswater_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.excesswater_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ойн зурвас </Label>
                      <Input
                        name="forest_strip"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.forest_strip || ""}
                        invalid={
                          validation.touched.forest_strip &&
                            validation.errors.forest_strip
                            ? true
                            : false
                        }
                      />
                      {validation.touched.forest_strip &&
                        validation.errors.forest_strip ? (
                        <FormFeedback type="invalid">
                          {validation.errors.forest_strip}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн дугаар </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>



                </Row>
                <Row>
                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"
                      onClick={() => console.log("Хадгалах товч дарлаа")}
                    > Хадгалах </button>
                  </Col>
                </Row>

              </Form>
          }
        </Col>
      </Row>
    </>
  )
}

export default Measurement;